import moment from 'moment';
import list from 'ngtemplate-loader!./list.tpl.html';
import { API } from './api';

export const moduleName = 'rezflow.bundleList'
export const name = 'bundleList';

export class BundleList {

  /* @ngInject */
  constructor($scope, $filter, BundleAPI, $state, $rootScope, $location, $transitions) {
    const vm = this;
    this.$scope = $scope;
    this.$filter = $filter;
    this._api = BundleAPI;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.user = $rootScope.user;
    this.company = this.user ? this.user.activeCompany : undefined;
  }

  get api() {
    return this._api;
  }

  $onInit() {
    this.init();
  }

  edit(id) {
    this.$state.go('editBundle', { id });
  }

  init() {
    this.api.req().list().$promise.then((bundles) => {
      console.log(bundles)
      this.bundles = bundles;
    })
  }

}

export default (MODULE) => {
  API(MODULE);
  angular.module(MODULE)
    .component(name, {
      bindings: {},
      templateUrl: list,
      controller: BundleList
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/bundles/index.js